const CHARGIFY_JS_VERSION = '2026-04-15';
const CHARGIFY_JS_SHA = '9a1ab99ca51ae8e093e80817f7d63867068546bd';

export default {
  // turn on or off the console logs from the app
  debug: false,
  version: CHARGIFY_JS_VERSION,

  recaptcha: {
    siteKey: {
      dev: '6Lch430rAAAAAIaMZJBmzt7lBEFp_RJFBNk7I9Hi',
      prod: '6Lc822srAAAAALL3-163uf2D9-XRBRh1jVRAxiok',
    },
  },

  server: {
    // path where static assets are located
    // jsHost: 'https://js.chargify.com/v/' + CHARGIFY_JS_VERSION,

    // path for the HTML of each iframe (i.e. '/path/to/html')
    iframePath: '/hosted-field.html',

    // path for the HTML to main iframe
    mainIframePath: '/main-iframe.html',

    // path for the API to the get token (i.e. '/path/to/token')
    tokenPath: '/js/tokens.json',

    // path for fetching Plaid Link Token
    plaidLinkTokenPath: '/js/plaid_link_tokens',

    // path for fetching Plaid Link Token Verification
    plaidLinkTokenVerificationPath: '/js/plaid_link_tokens/prepare_verification',

    // path for veryfing Plaid Account
    plaidVerifyAccountPath: '/js/tokens/verify_account',
  },

  // these numbers will be valid for credit card number (string)
  creditCardTestNumbers: ['1', '2', '3'],

  Honeybadger: {
    apiKey: 'hbp_4Tni1pwHt8A3ksR6FXZjWIYOWpgK972VSSSS',
    revision: CHARGIFY_JS_VERSION,
    enableUncaught: false,
    enableUnhandledRejection: false,
    projectRoot: 'webpack:///./src/',
  },
};
